import * as utils from '../utils';

export default async (cardUuid: string, event: string): Promise<utils.IProviderResponse<Record<string, any>>> => {
  let url;
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  if (event === 'birthdayShow') {
    url = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/mobigrams/${cardUuid}/opt_in_was_viewed`;
  }
  if (event === 'holidayShow') {
    url = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/mobigrams/${cardUuid}/opt_in_was_viewed`;
  }
  if (event === 'birthdayRemind') {
    url = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/mobigrams/${cardUuid}/opt_in_receiver_for_birthday_reminders`;
  }
  if (event === 'holidayRemind') {
    url = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/mobigrams/${cardUuid}/opt_in_receiver_for_holiday_reminders`;
  }
  if (event === 'promo') {
    url = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/mobigrams/${cardUuid}/opt_in_for_last_page_promo`;
  }

  if (!url) {
    return utils.ResponseError('Wrong action');
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      timezone: timeZone,
    }),
  }).then((res) => res.json());

  if (response?.error) {
    return utils.ResponseError(response?.error);
  }

  return utils.ResponseData(response);
};
